import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ConfigurationView } from 'pages/viewer/configurationController/ConfigurationViewer'
import { z } from 'zod'

export const Route = createFileRoute('/viewer/$unitID/configuration')({
  component: ConfigurationRouteComponent,
  staticData: {
    title: 'Configuration Viewer',
  },
  validateSearch: z.object({
    siteID: z.string().optional(),
    mode: z.enum(['2D', '3D']).optional(),
    selectedComponent: z.string().optional(),
    selectedComponentId: z.string().optional(),
    position: z
      .object({
        x: z.number().optional(),
        y: z.number().optional(),
        z: z.number().optional(),
      })
      .optional(),
    rotation: z
      .object({
        x: z.number().optional(),
        y: z.number().optional(),
        z: z.number().optional(),
      })
      .optional(),
  }),
})

function ConfigurationRouteComponent() {
  const { unitID } = Route.useParams()
  const searchParams = Route.useSearch()
  const navigate = useNavigate({ from: '/viewer/$unitID/configuration' })

  const handleModeChange = (mode: '2D' | '3D') => {
    navigate({
      search: (prev) => ({
        ...prev,
        mode,
      }),
    })
  }

  const handleSelectedComponentIdChange = (componentId: string | undefined) => {
    navigate({
      search: (prev) => {
        const newSearch = { ...prev }
        if (componentId === undefined) {
          delete newSearch.selectedComponentId
        } else {
          newSearch.selectedComponentId = componentId
        }
        return newSearch
      },
    })
  }

  return (
    <ConfigurationView
      unitID={unitID}
      mode={searchParams.mode}
      selectedComponentId={searchParams.selectedComponentId}
      onModeChange={handleModeChange}
      onSelectedComponentIdChange={handleSelectedComponentIdChange}
    />
  )
}
